<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2"
        >Skapa ersättningstrafik</v-card-title
      >

      <v-card-text class="mt-2">
        <v-row>
          <ReplacementTypeField />
          <v-col>
            <v-text-field
              label="Tågnummer"
              outlined
              type="number"
              v-model.number="model.train_number"
              :disabled="model.type === 'SHUTTLE'"
              :rules="[model.type !== 'SHUTTLE' ? required : () => true]"
            />
          </v-col>
        </v-row>

        <ReplacementFromToField />
        <ReplacementViaField />
        <ReplacementStatusField />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="createPending"
          >Skapa ersättningstrafik</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import ReplacementTypeField from './ReplacementForm/ReplacementTypeField'
import ReplacementStatusField from './ReplacementForm/ReplacementStatusField'
import ReplacementFromToField from './ReplacementForm/ReplacementFromToField'
import ReplacementViaField from './ReplacementForm/ReplacementViaField'

export default {
  name: 'ReplacementCreateModal',

  components: {
    ReplacementTypeField,
    ReplacementStatusField,
    ReplacementFromToField,
    ReplacementViaField
  },

  data: () => ({
    required,
    valid: true,
    createPending: false
  }),

  created() {
    this.$store.set(
      'replacement/model@event_uuid',
      this.$store.get('event/selectedUUID')
    )
  },

  computed: {
    model: sync('replacement/model')
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return

      this.createPending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateReplacementInput!) {
            createReplacement(payload: $payload) {
              replacement_uuid
            }
          }
        `,
        variables: {
          payload: {
            ...this.model,
            checked: true
          }
        }
      })

      this.createPending = false
      this.$store.commit('replacement/create', {
        ...this.model,
        checked: true
      })
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('replacement/resetModel')
      this.$emit('close')
    }
  }
}
</script>
